<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <!-- Dialog Vytvořit příspěvek -->
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title :class="{'py-0' : $vuetify.breakpoint.xs}">
            <h2>Vytvořit nový příspěvek</h2>
          </v-card-title>
          <v-card-text class="pa-0 pr-2" :class="{'pt-0 pb-2' : $vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Název" v-model="newItem.nazev" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    :items="items_kategorie"
                    :rules="rulesRequired"
                    label="Vyberte kategorii"
                    item-text="nazev_kategorie"
                    v-model="newItem.id_kategorie"
                    item-value="id"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog Smazat -->
      <v-dialog
        v-model="dialogDelete"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogDelete"
      >
        <v-card class="no__padding">
          <v-card-title :class="{'py-0' : $vuetify.breakpoint.xs}">
            <h2>Smazat příspěvek {{ deleteItem.name }}?</h2>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="deletePost()" :loading="sending">Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDelete=false" v-if="!sending">Zrušit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex grow>
                <h2>Videoblog</h2>
                <h3>Přehled příspěvků</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline  @click="dialogCreate=true">
                  <v-icon class="mr-2">add</v-icon>
                  Vytvořit příspěvek
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :rows-per-page-items="[3, 10, 25, 50, 100]"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.nazev }} <span v-if="props.item.smazano == 2"><i>(skrytý)</i></span>
                  </td>
                  <td>
                    {{ props.item.nazev_kategorie }}
                  </td>
                  <td>
                    <span v-if="props.item.jazyk == 'cs'">Česky</span>
                    <span v-else-if="props.item.jazyk == 'en'">Anglicky</span>
                  </td>
                  <td>
                    {{ props.item.datum | formatSimpleDate }}
                  </td>
                  <td>
                    {{ props.item.autor }}
                  </td>
                  <td class="text-xs-right">
                    <router-link :to="{ path: '/video-prispevky/'+props.item.id }">
                      <v-btn color="primary" class="elevation-0 mr-0">
                        <v-icon small class="mr-2">remove_red_eye</v-icon> Upravit
                      </v-btn>
                    </router-link>
                    <v-btn @click="dialogDelete=true; deleteItem.id=props.item.id; deleteItem.name=props.item.nazev" color="red" dark class="elevation-0 mr-0">
                      <v-icon small class="mr-2">delete</v-icon> Smazat
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      totalItems: {},
      newItem: {},
      deleteItem: {},
      sending: false,
      headers: [
          { text: 'Název příspěvku', value: 'nazev_kategorie'},
          { text: 'Kategorie', value: 'kategorie'},
          { text: 'Jazyk', value: 'jazyk'},
          { text: 'Datum', value: 'datum' },
          { text: 'Autor', value: 'autor' },
          { text: '', value: null, sortable: false, align: 'right' },
        ],
      items: [],
      items_kategorie: [],
      id_kategorie: "",
      loadingTable: true,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "poradi",
        totalItems: 0
      },
      dialogCreate: false,
      dialogDelete: false,
      valid: true,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
    }
  },
  mounted: function() {
    this.load();
    this.getCategories();
  },
  methods: {
    load: function(v) {
      window.api.get("videoblog/prispevky/all").then(function(_body) {
        this.items = _body;
        this.loadingTable = false;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("videoblog/prispevky/new", this.newItem).then(function(body) {
          if (body.created) {
            this.dialogCreate = false;
            this.$router.push({ name: 'VideoBlogPrispevkyDetail', params: { id: body.id } })
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    getCategories () {
      window.api.get("videoblog/kategorie/all").then(function(_body) {
        this.items_kategorie = _body;
        this.loadingTable = false;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    deletePost () {
      this.sending = true;
      window.API.delete("videoblog/prispevky/del/"+this.deleteItem.id).then(function(body) {
        this.sending = false;
        this.dialogDelete = false;
        this.load();
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/VideoBlog/VideoBlogPrispevky.vue